import React from 'react'

import BaseModal from 'components/Modals/BaseModal'
import EmployeeSchedule from 'Employee/schedule/EmployeeSchedule'
import { getUserName } from 'services/Utilities'

function ScheduleOpenEmployeeSchedule({ employeeId, defaultDate }) {
  return (
    <BaseModal wideModal title={`manager.schedule.EMPLOYEE_SCHEDULE`} titleVar={{ employeeName: getUserName(employeeId, { showEmployeeNumber: true }) }}>
      <EmployeeSchedule userId={employeeId} defaultDate={defaultDate} />
    </BaseModal>
  )
}

export default ScheduleOpenEmployeeSchedule
